// Vendors
import { CountriesLocaleEnum, StorageLocalEnum } from '@openbank/ziniaweb-ui-core-models';
// Constants
import { ALLOWED_LANGUAGES } from './constants/internationalization.hook.utils.constants';
// Types
import { InternationalizationHookUtilsType } from './types/internationalization.hook.utils.type';

const getUserLanguage = ({ languagePreference }: InternationalizationHookUtilsType): string =>
  languagePreference && ALLOWED_LANGUAGES?.includes(languagePreference as CountriesLocaleEnum)
    ? languagePreference
    : CountriesLocaleEnum.SPAIN;

const getTranslationsFromStorage = (): { value: string[] } | Record<string, never> =>
  JSON.parse(localStorage.getItem(StorageLocalEnum.TRANSLATIONS) || '{}');

export { getTranslationsFromStorage, getUserLanguage };
